
import Dialog from '~/components/ui/Dialog.vue'
import TrustPilotLogo from '~/components/ui/icon/TrustPilotLogo.vue';

export default {
    name: 'MoneyBackGuaranteeDialog',
    components: { Dialog, TrustPilotLogo },
    data: () => ({

    }),
    computed: {
        baseUrl() { return process.env.BASE_URL },
        isMobile() { return this.$store.state.store.isMobile },
    },
    created() {
    },
    methods: {
        open(props) {
            this.openDialog()
        },
        openDialog() {
            this.$refs.MoneyBackGuaranteeDialog.open()
        }
    }
}
